import { isNullOrBlank } from '@/src/lib/MayzSmartDB';
import { COPY2 } from "@/src/lib/SmartDB/Commons/Constants/images";
import styles from './CopyButton.module.scss';
import { useCopyButton } from './useCopyButton';
import Image from 'next/image';

export default function CopyButton({ content }: { content: string }) {
    //--------------------------------------
    const { handleBtnCopy } = useCopyButton();
    //--------------------------------------
    return (
        <>
            {isNullOrBlank(content) === false && (
                // <svg width="12" height="12" className={styles.icon} onClick={() => handleBtnCopy(content)}>
                //     <use href={COPY}></use>
                // </svg>
                <div className={styles.icon}>
                    <Image src={COPY2} alt={content} title={content} width="100%" height="100%" layout="responsive" objectFit="contain" onClick={() => handleBtnCopy(content)} />
                </div>
            )}
        </>
    );
}
